import { MetricsClient } from '@agilelab/plugin-wb-metrics-common';
import { createApiRef } from '@mainstage/core-plugin-api';

export const metricsApiRef = createApiRef<MetricsClient>({
  id: 'wb-metrics',
});
